// CattleNewWeighInModal — thin cattle wrapper over RuminantNewWeighInModal.
import {
  RuminantNewWeighInModal,
  type LockedTeamMemberSource,
  type NewRuminantWeighInSession,
  type RuminantGroupOption,
} from './ruminantPresentation.js';

export type NewCattleWeighInSession = NewRuminantWeighInSession;

type CattleNewWeighInModalProps = {
  onClose: () => void;
  onCreate: (session: NewCattleWeighInSession) => Promise<void>;
  authState?: LockedTeamMemberSource | null;
};

const HERD_OPTS: readonly RuminantGroupOption[] = [
  {v: 'mommas', l: 'Mommas'},
  {v: 'backgrounders', l: 'Backgrounders'},
  {v: 'finishers', l: 'Finishers'},
  {v: 'bulls', l: 'Bulls'},
];

const CattleNewWeighInModal = ({onClose, onCreate, authState}: CattleNewWeighInModalProps) => (
  <RuminantNewWeighInModal
    title="New Cattle Weigh-In"
    groupLabel="Herd"
    groupPlaceholder="Select herd…"
    missingGroupError="Pick a herd."
    options={HERD_OPTS}
    onClose={onClose}
    onCreate={onCreate}
    authState={authState}
  />
);

export default CattleNewWeighInModal;
